import { ReactElement, useEffect, useState } from 'react';
import {
  capitalizeFirstLetter,
  getCountryFromCode,
  getMaterialsFromId,
} from '../utils/utils';
import { getProductsCategories } from '../controller/productController';
import { getCountries, getMaterials } from '../controller/ecobalyseController';
import CheckMark from '../icon/CheckMark';
import AlmostEqual from '../icon/AlmostEqual';
import CrossSign from '../icon/CrossSign';

export enum Reliability {
  GOOD,
  MEDIUM,
  BAD,
}

const Tooltip = ({ reliability }: any) => {
  let icon;
  let text;

  switch (reliability) {
    case Reliability.GOOD:
      icon = <CheckMark />;
      text = 'Donnée fiable';
      break;
    case Reliability.MEDIUM:
      icon = <AlmostEqual />;
      text = 'Donnée peu fiable';
      break;
    default:
      icon = <CrossSign />;
      text = 'Donnée non transmise';
  }

  return (
    <div
      className={`absolute bottom-full left-1/2 ${
        reliability === Reliability.MEDIUM
          ? '-translate-x-48'
          : reliability === Reliability.BAD
          ? '-translate-x-40'
          : '-translate-x-36'
      } mb-2 px-3 py-2 bg-black text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-300 whitespace-nowrap flex items-center gap-2`}
    >
      {icon}
      <span>{text}</span>
    </div>
  );
};

function InformationElement(props: {
  children: ReactElement<any, any>[];
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  return (
    <div
      className="flex items-center justify-between group"
      onClick={() => {
        if (!props.modifying[props.id]) {
          props.setModifying((prev: any) => ({ ...prev, [props.id]: true }));
        }
      }}
    >
      <p className="text-darkLight dark:text-whiteLight">{props.name}</p>
      {!props.modifying[props.id] && (
        <div className="flex gap-2 items-center">
          {props.children[0]}
          {/* <div className="w-0 transition-all duration-500 group-hover:w-10 overflow-hidden cursor-pointer"> */}
          {/* <div className="bg-secondary flex justify-center items-center w-8 h-8 rounded-full">
                          <svg
                            className="w-5"
                            fill="#FFFFFF"
                            viewBox="0 0 64 64"
                            version="1.1"
                          >
                            <path d="M55.944,51.712l0,4.201l-33.652,-0.027l4.71,-4.174l28.942,0Zm-7.555,-43.712c1.649,0 2.505,0.128 4.752,2.011c2.294,1.921 2.707,3.419 2.803,5.087c0.102,1.795 -0.504,3.976 -2.188,5.681l-31.961,31.961c-0.52,0.475 -0.629,0.45 -0.977,0.553l-10.226,2.557c-1.472,0.299 -2.854,-1.049 -2.55,-2.55l2.557,-10.226c0.1,-0.334 0.133,-0.517 0.553,-0.976c10.696,-10.697 21.195,-21.594 32.09,-32.087c1.421,-1.335 3.497,-2.011 5.147,-2.011Zm-32.375,35.182l-1.477,1.477l-1.566,6.262l6.262,-1.566c0.493,-0.492 0.985,-0.983 1.479,-1.474l-4.698,-4.699Zm30.176,-20.573l-4.802,-4.801l-22.493,22.493l4.712,4.713c7.549,-7.448 15.196,-14.801 22.583,-22.405Zm2.826,-2.936c0.618,-0.648 1.234,-1.298 1.848,-1.951c1.673,-1.826 0.443,-5.454 -2.307,-5.578c-0.056,-0.002 -0.112,-0.002 -0.168,-0.002c-0.861,0.016 -1.699,0.372 -2.312,0.977l-1.807,1.808l4.746,4.746Z" />
                          </svg>
                        </div> */}
          {/* </div> */}
          <div className="relative inline-block group">
            {props.reliability === Reliability.GOOD && <CheckMark />}
            {props.reliability === Reliability.MEDIUM && <AlmostEqual />}
            {props.reliability === Reliability.BAD && <CrossSign />}
            {/* <div
              className={`w-3 h-3 rounded-full ${
                props.reliability === Reliability.GOOD
                  ? 'bg-score1'
                  : props.reliability === Reliability.MEDIUM
                  ? 'bg-score3'
                  : 'bg-score6'
              }`}
            ></div> */}
            <Tooltip reliability={props.reliability} />
          </div>
        </div>
      )}
      {props.modifying[props.id] && (
        <div className="flex items-center w-1/2 md:w-auto">
          {props.children[1]}
        </div>
      )}
    </div>
  );
}

function DisplayMaterials(props: { fullMaterials: any; materials: any }) {
  return (
    <div>
      {Object.keys(props.materials).map((mat) => {
        return (
          <p key={mat} className="text-end">
            {props.fullMaterials.length > 0
              ? getMaterialsFromId(mat, props.fullMaterials) +
                ' : ' +
                Math.round(props.materials[mat] * 100) +
                '%'
              : ''}
          </p>
        );
      })}
    </div>
  );
}

export function TextInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>{capitalizeFirstLetter(props.value)}</p>
      <input
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 w-full md:w-auto"
        name="color"
        type="text"
        value={capitalizeFirstLetter(props.value)}
        onChange={(e) => props.setValue(e.target.value)}
      />
    </InformationElement>
  );
}

export function NumberInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
  max?: number;
  min?: number;
}) {
  const text =
    props.value === '' ? (
      <p className="italic text-darkLight dark:text-whiteLight text-base">
        Non renseigné
      </p>
    ) : (
      <p>
        {props.value} {props.name === 'Poids' && <span>g</span>}
      </p>
    );
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      {text}
      <input
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-full"
        type="number"
        min={props.min ? props.min : 0}
        max={props.max}
        value={Number.isNaN(parseInt(props.value)) ? 0 : parseInt(props.value)}
        onChange={(e) => props.setValue(e.target.value.toString())}
      />
    </InformationElement>
  );
}

export function CategoryInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const [fullCategories, setFullCategories] = useState<string[]>([]);

  useEffect(() => {
    getProductsCategories().then((categories) => {
      if (categories.sub_categories) {
        setFullCategories(categories.sub_categories);
      }
    });
  }, []);

  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>{capitalizeFirstLetter(props.value)}</p>
      <select
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-full"
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
      >
        {fullCategories.map((cat) => {
          return (
            <option key={cat} value={cat}>
              {capitalizeFirstLetter(cat)}
            </option>
          );
        })}
      </select>
    </InformationElement>
  );
}

export function CountryInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const [fullCountries, setFullCountries] = useState<any[]>([]);

  useEffect(() => {
    getCountries().then((countries) => {
      setFullCountries(countries);
    });
  }, []);
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>
        {fullCountries.length > 0
          ? getCountryFromCode(props.value, fullCountries)
          : ''}
      </p>
      <select
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-full"
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
      >
        {fullCountries.map((country) => {
          return (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          );
        })}
      </select>
    </InformationElement>
  );
}

export function MaterialsInformationElement(props: {
  value: any;
  setValue: React.Dispatch<React.SetStateAction<any>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const [fullMaterials, setFullMaterias] = useState<any[]>([]);

  const [materials, setMaterials] = useState<any>(Object.keys(props.value));
  const [proportions, setProportions] = useState<any>(
    Object.values(props.value),
  );

  useEffect(() => {
    getMaterials().then((materials) => {
      setFullMaterias([...materials, { id: '', name: '' }]);
    });
  }, []);

  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <DisplayMaterials materials={props.value} fullMaterials={fullMaterials} />
      <div className="flex flex-col gap-2 items-end">
        {materials.map((val: any, i: number) => {
          return (
            <div key={val} className="flex items-center">
              <select
                className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-56 w-2/3"
                value={materials[i]}
                onChange={(e) => {
                  let tmp = { ...props.value };
                  tmp[e.target.value] = props.value[val];
                  delete tmp[val];
                  props.setValue(tmp);
                  tmp = materials;
                  tmp[i] = e.target.value;
                  setMaterials(tmp);
                }}
              >
                {fullMaterials.map((mat: any) => {
                  return (
                    <option key={mat.id} value={mat.id}>
                      {mat.name}
                    </option>
                  );
                })}
              </select>
              <input
                className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-1/3"
                type="number"
                min={0}
                value={Math.round(proportions[i] * 100)}
                onChange={(e) => {
                  props.setValue({
                    ...props.value,
                    [val]: parseInt(e.target.value) / 100,
                  });
                  let tmp = proportions;
                  tmp[i] = parseInt(e.target.value) / 100;
                  setProportions(tmp);
                }}
              />
              <svg
                className="w-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => {
                  let tmp = { ...props.value };
                  delete tmp[val];
                  props.setValue(tmp);
                  delete materials[i];
                  delete proportions[i];
                }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
                  fill="currentColor"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L6.53035 18.5303C6.23745 18.8232 5.76258 18.8232 5.46969 18.5303C5.17679 18.2374 5.17679 17.7626 5.46968 17.4697L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          );
        })}
        <div
          className="bg-secondary p-1 rounded-full mt-2 transition-all duration-500 cursor-pointer hover:scale-105"
          onClick={() => {
            props.setValue((prevValue: any) => ({ ...prevValue, '': 0 }));
            materials.push('');
            proportions.push(0);
          }}
        >
          <svg
            className="w-6"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </InformationElement>
  );
}

export function SizesInformationElement(props: {
  value: string[];
  setValue: React.Dispatch<React.SetStateAction<string[]>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>{props.value.join(', ').toUpperCase()}</p>
      <div className="flex flex-col items-end gap-2 mr-2 md:w-auto w-full">
        {props.value.map((size, i) => {
          return (
            <div className="flex" key={i}>
              <input
                className="text-black md:text-base text-sm p-2 rounded-lg w-28"
                name="size"
                type="text"
                value={capitalizeFirstLetter(size)}
                onChange={(e) => {
                  props.setValue((prevValue: string[]) =>
                    prevValue.map((el: any, idx: any) => {
                      if (idx === i) {
                        return e.target.value;
                      }
                      return el;
                    }),
                  );
                }}
              />
              <svg
                className="w-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() =>
                  props.setValue((prevValue: any) =>
                    prevValue.filter((_: any, idx: number) => idx !== i),
                  )
                }
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
                  fill="currentColor"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L6.53035 18.5303C6.23745 18.8232 5.76258 18.8232 5.46969 18.5303C5.17679 18.2374 5.17679 17.7626 5.46968 17.4697L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          );
        })}
        <div
          className="bg-secondary p-1 rounded-full mt-2 transition-all duration-500 cursor-pointer hover:scale-105"
          onClick={() => props.setValue((prevValue: any) => [...prevValue, ''])}
        >
          <svg
            className="w-6"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </InformationElement>
  );
}

export function MaterialComplexityInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const materialComplexity: any = {
    'very-high': 'Très élevée',
    high: 'Élevée',
    medium: 'Moyenne',
    low: 'Faible',
    'very-low': 'Très faible',
  };

  const text =
    props.value === '' ? (
      <p className="italic text-darkLight dark:text-whiteLight text-base">
        Non renseigné
      </p>
    ) : (
      <p>{materialComplexity[props.value]}</p>
    );
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>{text}</p>
      <select
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-full"
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
      >
        {Object.keys(materialComplexity).map((compl) => {
          return (
            <option key={compl} value={compl}>
              {materialComplexity[compl]}
            </option>
          );
        })}
      </select>
    </InformationElement>
  );
}

export function FadingInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const booleans: any = {
    '': '',
    true: 'Vrai',
    false: 'Faux',
  };

  const text =
    props.value === '' ? (
      <p className="italic text-darkLight dark:text-whiteLight text-base">
        Non renseigné
      </p>
    ) : (
      <p>{booleans[props.value]}</p>
    );
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>{text}</p>
      <select
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-full"
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
      >
        {Object.keys(booleans).map((compl) => {
          return (
            <option key={compl} value={compl}>
              {booleans[compl]}
            </option>
          );
        })}
      </select>
    </InformationElement>
  );
}

export function HeatSourceInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const heatSources: any = {
    '': '',
    coal: 'Charbon',
    naturalgas: 'Gaz naturel',
    lightfuel: 'Fioul léger',
    heavyfuel: 'Fioul lourd',
  };

  const text =
    props.value === '' ? (
      <p className="italic text-darkLight dark:text-whiteLight text-base">
        Non renseigné
      </p>
    ) : (
      <p>{heatSources[props.value]}</p>
    );
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>{text}</p>
      <select
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-full"
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
      >
        {Object.keys(heatSources).map((compl) => {
          return (
            <option key={compl} value={compl}>
              {heatSources[compl]}
            </option>
          );
        })}
      </select>
    </InformationElement>
  );
}

export function DyeingMediumInformationElement(props: {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const dyeingMedium: any = {
    '': '',
    article: 'Article',
    fabric: 'Tissu',
    yarn: 'Fil',
  };

  const text =
    props.value === '' ? (
      <p className="italic text-darkLight dark:text-whiteLight text-base">
        Non renseigné
      </p>
    ) : (
      <p>{dyeingMedium[props.value]}</p>
    );
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      <p>{text}</p>
      <select
        className="text-black md:text-base text-sm p-2 rounded-lg mr-2 md:w-auto w-full"
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
      >
        {Object.keys(dyeingMedium).map((compl) => {
          return (
            <option key={compl} value={compl}>
              {dyeingMedium[compl]}
            </option>
          );
        })}
      </select>
    </InformationElement>
  );
}

export function PrintingInformationElement(props: {
  value: any;
  setValue: React.Dispatch<React.SetStateAction<any>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const text =
    props.value['pigment'] === 0 && props.value['substantive'] === 0 ? (
      <p className="italic text-darkLight dark:text-whiteLight text-base">
        Non renseigné
      </p>
    ) : (
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 justify-end">
          <p>Pigmentaire : {Math.round(props.value['pigment'] * 100)}%</p>
        </div>
        <div className="flex gap-2 justify-end">
          <p>Fixé/Lavé : {Math.round(props.value['substantive'] * 100)}%</p>
        </div>
      </div>
    );
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      {text}
      <div className="flex flex-col gap-2 justify-end md:w-auto w-full">
        <div className="flex gap-2 items-center justify-end">
          <p className="text-xs md:text-base">Pigmentaire :</p>
          <input
            className="text-black md:text-base text-sm p-2 rounded-lg"
            type="number"
            min={0}
            max={100}
            value={Math.round(props.value['pigment'] * 100)}
            onChange={(e) =>
              props.setValue((prev: any) => ({
                ...prev,
                pigment: parseInt(e.target.value) / 100,
              }))
            }
          />
          <p className="mr-2">%</p>
        </div>
        <div className="flex gap-2 items-center justify-end">
          <p className="text-xs md:text-base">Fixé/Lavé :</p>
          <input
            className="text-black md:text-base text-sm p-2 rounded-lg"
            type="number"
            min={0}
            max={100}
            value={Math.round(props.value['substantive'] * 100)}
            onChange={(e) =>
              props.setValue((prev: any) => ({
                ...prev,
                substantive: parseInt(e.target.value) / 100,
              }))
            }
          />
          <p className="mr-2">%</p>
        </div>
      </div>
    </InformationElement>
  );
}

export function DisabledStepsInformationElement(props: {
  value: string[];
  setValue: React.Dispatch<React.SetStateAction<string[]>>;
  name: string;
  reliability: Reliability;
  modifying: any;
  id: string;
  setModifying: React.Dispatch<any>;
}) {
  const steps: any = {
    '': '',
    material: 'Matière',
    spinning: 'Filature',
    fabric: 'Tissage ou Tricotage',
    ennobling: 'Ennoblissement',
    making: 'Confection',
    distribution: 'Distribution',
    use: 'Utilisation',
    eol: 'Fin de vie',
  };

  const text =
    props.value.length === 0 ? (
      <p className="italic text-darkLight dark:text-whiteLight text-base">
        Non renseigné
      </p>
    ) : (
      <p>{props.value.map((step) => steps[step]).join(', ')}</p>
    );
  return (
    <InformationElement
      name={props.name}
      reliability={props.reliability}
      modifying={props.modifying}
      id={props.id}
      setModifying={props.setModifying}
    >
      {text}
      <div className="flex flex-col items-end gap-2 mr-2">
        {props.value.map((disabledStep, i) => {
          return (
            <div className="flex" key={i}>
              <select
                className="text-black text-base p-2 rounded-lg mr-2 md:w-auto w-full"
                value={disabledStep}
                onChange={(e) => {
                  props.setValue((prevValue: string[]) =>
                    prevValue.map((el: any, idx: any) => {
                      if (idx === i) {
                        return e.target.value;
                      }
                      return el;
                    }),
                  );
                }}
              >
                {Object.keys(steps).map((step) => {
                  return (
                    <option key={step} value={step}>
                      {steps[step]}
                    </option>
                  );
                })}
              </select>
              <svg
                className="w-6"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() =>
                  props.setValue((prevValue: any) =>
                    prevValue.filter((_: any, idx: number) => idx !== i),
                  )
                }
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
                  fill="currentColor"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L6.53035 18.5303C6.23745 18.8232 5.76258 18.8232 5.46969 18.5303C5.17679 18.2374 5.17679 17.7626 5.46968 17.4697L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          );
        })}
        <div
          className="bg-secondary p-1 rounded-full mt-2 transition-all duration-500 cursor-pointer hover:scale-105"
          onClick={() => props.setValue((prevValue: any) => [...prevValue, ''])}
        >
          <svg
            className="w-6"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 4C12.5523 4 13 4.44772 13 5V11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H11V5C11 4.44772 11.4477 4 12 4Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </InformationElement>
  );
}
